module.exports = __webpack_public_path__ + "img/british-Airways.d473cf19.png";